import { createReducer, on } from "@ngrx/store";
import { CardEnvironment } from "src/model/class/general classes/card-environment";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  cardEnvironmentAssignTimeSlotAction,
  cardEnvironmentLoadErrorAction,
  cardEnvironmentLoadSuccessAction,
  cardEnvironmentStartLoadAction,
  cardEnvironmentSwithcActiveSuccessAction,
  cardEnvironmentAssignCalendarAction,
} from "../actions/card-environment.actions";

/**
 * Initial state of card environment store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

export const CardEnvironmentReducer = createReducer(
  initialState,
  on(
    cardEnvironmentStartLoadAction,
    (cardEnvironemntObject: GenericStoreApiData, action) => {
      return { ...cardEnvironemntObject, loaded: false };
    }
  ),
  on(
    cardEnvironmentLoadSuccessAction,
    (cardEnvironemntObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.listCardEnvironmentObject,
      };
    }
  ),
  on(
    cardEnvironmentLoadErrorAction,
    (cardEnvironemntObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null,
      };
    }
  ),
  on(
    cardEnvironmentAssignTimeSlotAction,
    (cardEnvironmentObject: GenericStoreApiData, action) => {
      const updateCardEnvironment: CardEnvironment = action.cardEnvironment;

      let listCardEnvironment: Array<CardEnvironment> = [...(cardEnvironmentObject.data?.data || [])];

      const listCardEnvironmentUpdated = listCardEnvironment.map(
        (cardEnvironment: CardEnvironment) => {
          if (cardEnvironment.id === action.cardEnvironment.id) {
            cardEnvironment = {
              ...cardEnvironment,
              idTimeSlot: action.idTimeSlot,
            };
          }

          return cardEnvironment;
        }
      );

      return {
        ...cardEnvironmentObject,
        data: {
          lastAPIModified: null,
          data: listCardEnvironmentUpdated,
        },
      };
    }
  ),
  on(
    cardEnvironmentAssignCalendarAction,
    (cardEnvironmentObject: GenericStoreApiData, action) => {
      const updateCardEnvironment: CardEnvironment = action.cardEnvironment;

      let listCardEnvironment: Array<CardEnvironment> = [...(cardEnvironmentObject.data?.data || [])];

      const listCardEnvironmentUpdated = listCardEnvironment.map(
        (cardEnvironment: CardEnvironment) => {
          if (cardEnvironment.id === action.cardEnvironment.id) {
            cardEnvironment = {
              ...cardEnvironment,
              idCalendar: action.idCalendar,
            };
          }

          return cardEnvironment;
        }
      );

      return {
        ...cardEnvironmentObject,
        data: {
          lastAPIModified: null,
          data: listCardEnvironmentUpdated,
        },
      };
    }
  ),
  on(
    cardEnvironmentSwithcActiveSuccessAction,
    (cardEnvironemntObject: GenericStoreApiData, action) => {
      const updateCardEnvironment: CardEnvironment = action.cardEnvironment;

      let listUpdateCardEnvironment: Array<CardEnvironment> = [...(cardEnvironemntObject.data?.data || [])];


      if (!updateCardEnvironment.active) {
        listUpdateCardEnvironment = listUpdateCardEnvironment.filter(
          (ce: CardEnvironment) => ce.id !== updateCardEnvironment.id
        );
      } else {
        listUpdateCardEnvironment = [
          ...listUpdateCardEnvironment,
          updateCardEnvironment,
        ];
      }

      return {
        ...cardEnvironemntObject,
        data: {
          lastAPIModified: null,
          data: listUpdateCardEnvironment,
        },
      };
    }
  )
);
